export default {
  title: 'Facturas de pedidos',
  list: {
    empty_list: {
      title: 'Aún no hay facturas de pedidos.',
    },
    fields: {
      id: 'Id',
      total: 'Total',
      date: 'Fecha',
    },
  },
  export_modal: {
    title: 'Filtrar',
    start_date: {
      title: 'Fecha de inicio',
      placeholder: 'fecha',
    },
    end_date: {
      title: 'Fecha de fin',
      placeholder: 'fecha',
    },
    button: {
      title1: 'Aplicar',
      title2: 'Cerrar',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
